import { Button } from '@/components/ui/button';

import { CampClase } from './CampClase';

/**
 * Ecranul „care clase" — ULTIMUL pas al activitatii practice (SP-05a), si cel de pe care pleaca
 * trimiterea.
 *
 * 🔴 De ce ecran propriu, si nu un camp pe ultimul slide (decizia S1, 2026-09-06): lista de clase
 * e singura intrare din tot fluxul care decide recompensa. Pusa sub pozele tocmai incarcate,
 * ajunge la 360px sub linia de indoire impreuna cu oglinda (doua-trei randuri de etichete) si cu
 * eroarea — adica un camp care determina punctajul si pe care trebuie sa-l cauti prin scroll.
 * Pasul in plus se plateste o data per activitate.
 *
 * ⚠️ NU e slide-ul de participanti cu alt continut. Acela apare DUPA trimitere si face o a doua
 * scriere pe `lessonAnswerId`. Aici `clase` pleaca in ACEEASI cerere cu raspunsul ultimului slide
 * real, deci ecranul e INAINTE de trimitere si butonul de aici e cel care trimite.
 *
 * 🔴 ZERO ARITMETICA PE ECRAN (directia S1). Nicaieri „50 de puncte pe clasă": o intrebare devine
 * negociere in clipa in care spui cat platesti pentru raspuns, iar aici raspunsul il verifica un
 * om abia la aprobare. Titlul spune la ce foloseste, nu cat valoreaza.
 *
 * ⚠️ Campul e OPTIONAL — fara clase activitatea ia tot 50 de puncte, deci gol e o cale legala.
 * Confirmarea la gol se cere O SINGURA data, si nu contine cifre; mecanismul e in hook
 * (`golConfirmat`), nu aici, ca sa nu existe doi decidenti pentru aceeasi intrebare.
 */

export interface EcranClaseProps {
    value: string;
    onChange: (value: string) => void;
    onSubmit: () => void;
    isSubmitting: boolean;
    /** Fragmentele respinse de SERVER (400) — vin din `fragmenteNerecunoscute`. */
    fragmenteRespinse?: string[];
    /**
     * Clasele pe care serverul le raporteaza ca deja punctate, din raspunsul de 201.
     * AVERTIZARE, nu refuz: trimiterea a reusit deja cand omul citeste asta.
     */
}

export function EcranClase({
    value,
    onChange,
    onSubmit,
    isSubmitting,
    fragmenteRespinse,
}: EcranClaseProps) {
    return (
        <div className="ecotic-form-card space-y-6">
            <div className="space-y-2">
                <h2 className="text-2xl font-bold text-foreground">
                    La ce clase ați făcut activitatea?
                </h2>
                <p className="text-muted-foreground">
                    Scrie clasele care au participat. Le poți șterge sau adăuga până trimiți.
                </p>
            </div>

            <CampClase
                value={value}
                onChange={onChange}
                disabled={isSubmitting}
                fragmenteRespinse={fragmenteRespinse}
            />

            {/* Avertizarea „clase deja punctate" NU mai e aici, si nu din stil.
                Era nerandabila prin constructie: lista intra in state la trimitere, iar
                acelasi handler face `COMPLETE_LESSON`, dupa care `LessonPlayer` iese pe
                return-ul timpuriu cu `CompletionScreen` — deci ecranul asta se demonteaza
                exact atunci. Return-ul acela e DEASUPRA ramurii care monteaza ecranul de
                fata, si asta se citeste din sursa.
                ⚠️ Aici scria „React grupeaza cele doua `setState`". NU s-a masurat, si nici
                nu e portant: cu grupare — niciun render cu lista nevida; fara — un singur
                cadru, nelizibil oricum.
                Nu lasam un prop care nu poate rula: a fost SCOS din interfata, nu doar
                nefolosit. Un prop declarat si tipat care nu ajunge niciodata pe ecran e
                exact ce ne-a costat de doua ori in valul asta. Vezi `clase-avertizare.ts`. */}

            <div className="flex justify-center pt-2">
                {/* ⚠️ „Trimite spre aprobare", nu „Finalizează": activitatea practica chiar trece
                    pe la un om. Iar dupa trimitere confirmarea e tot «Trimis spre aprobare» —
                    ruta intoarce 201 si pentru o clasa deja punctata, deci nu putem promite ca
                    s-a inregistrat sau s-a punctat ceva. */}
                <Button
                    onClick={onSubmit}
                    disabled={isSubmitting}
                    size="lg"
                    className="min-w-[200px]"
                >
                    {isSubmitting ? 'Se trimite...' : 'Trimite spre aprobare'}
                </Button>
            </div>
        </div>
    );
}
